import { ServiceTypeEnum } from 'utils/enums';
import {
  getOptions4Type,
  mapChipFieldOptions,
  mapToggleFieldOptions,
} from 'features/consults/utils/formFields';
import { neuroPlanFields as fields } from 'features/consults/shared/tabs/Plan/formFields';

export const bloodPressureElements = [
  mapChipFieldOptions(fields.bloodPressureManagementPredefined),
  fields.bloodPressureManagementFreeText,
  mapToggleFieldOptions(fields.targetBloodPressureBelowPredefined),
  mapToggleFieldOptions(fields.targetBloodPressureAbovePredefined),
  mapToggleFieldOptions(fields.targetBloodPressureDiastolicPredefined),
  mapToggleFieldOptions(fields.targetBloodPressureRangePredefined),
  fields.targetBloodPressureFreeText,
];

export const rightElements = [
  mapChipFieldOptions(
    getOptions4Type(fields.labsPredefined, ServiceTypeEnum.NEURO),
  ),
  fields.labsFreeText,
  mapChipFieldOptions(fields.imagingUrgencySTATPredefined),
  fields.imagingUrgencySTATFreeText,
  mapChipFieldOptions(
    getOptions4Type(
      fields.imagingUrgencyRoutinePredefined,
      ServiceTypeEnum.NEURO,
    ),
  ),
  fields.imagingUrgencyRoutineFreeText,
  mapChipFieldOptions(
    getOptions4Type(
      fields.imagingDiagnosticsUrgencyOutpatientPredefined,
      ServiceTypeEnum.NEURO,
    ),
  ),
  fields.imagingDiagnosticsUrgencyOutpatientFreeText,
  mapChipFieldOptions(
    getOptions4Type(fields.diagnosticTestPredefined, ServiceTypeEnum.NEURO),
  ),
  fields.diagnosticTestFreeText,
  mapChipFieldOptions(
    getOptions4Type(fields.therapyEvaluationPredefined, ServiceTypeEnum.NEURO),
  ),
  fields.therapyEvaluationFreeText,
  mapChipFieldOptions(
    getOptions4Type(fields.medicationsPredefined, ServiceTypeEnum.NEURO),
  ),
  fields.medicationsFreeText,
  mapChipFieldOptions(
    getOptions4Type(fields.vteProphylaxisPredefined, ServiceTypeEnum.NEURO),
  ),
  fields.vteProphylaxisFreeText,
  mapChipFieldOptions({
    ...fields.hemorrhageReversalPredefined,
    options: fields.hemorrhageReversalPredefined.options.filter(
      ({ value }) => value !== 'AndexanetAndexXa',
    ),
  }),
  fields.hemorrhageReversalFreeText,
  mapChipFieldOptions(
    getOptions4Type(fields.otherPredefined, ServiceTypeEnum.NEURO),
  ),
  fields.otherFreeText,

  mapChipFieldOptions(fields.additionalRecommendations),
  fields.additionalRecommendationsFreeText,

  mapToggleFieldOptions(
    getOptions4Type(fields.dispositionPredefined, ServiceTypeEnum.NEURO),
  ),
];
